import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { ROUTES } from './app.routes';

import { IonicModule } from '@ionic/angular';
import { AdminModule } from './admin/admin.module';
import { AppLoadModule } from './app-load/app-load.module';
import { BuildAssembliesModule } from './build-assemblies/build-assemblies.module';
import { LayoutsModule } from './common/layouts/layouts.module';
import { ConfirmationsModule } from './confirmation/confirmations.module';
import { CoreModule } from './core/core.module';
import { DealersModule } from './dealers/dealers.module';
import { InvoicesModule } from './invoices/invoices.module';
import { OrdersModule } from './orders/orders.module';
import { OverviewsModule } from './overviews/overviews.module';
import { PartsModule } from './parts/parts.module';
import { PaymentsModule } from './payments/payments.module';
import { PicturesModule } from './pictures/pictures.module';
import { PortalModule } from './portal/portal.module';
import { PurchaseOrdersModule } from './purchase-orders/purchase-orders.module';
import { ReportsModule } from './reports/reports.module';
import { SchedulingModule } from './scheduling/scheduling.module';
import { SharedModule } from './shared/shared.module';
import { VendorsModule } from './vendors/vendors.module';
import { WeldShopModule } from './weld-shop/weld-shop.module';
import { ContactLogsModule } from './contact-log/contact-logs.module';
import { PackingSlipsModule } from './packing-slips/packing-slips.module';
import { SalesModule } from './sales/sales.module';
import { ExpenseReportsModule } from './expense-reports/expense-reports.module';
import { InventoryProjectionsModule } from './inventory-projections/inventory-projections.module';
import { UpdateBannerComponent } from './shared/update-banner.component';
@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        LayoutsModule,
        AppLoadModule,
        CoreModule.forRoot(),
        RouterModule.forRoot(ROUTES, {}),
        AdminModule,
        InvoicesModule,
        PaymentsModule,
        PicturesModule,
        DealersModule,
        VendorsModule,
        OrdersModule,
        PackingSlipsModule,
        OverviewsModule,
        ReportsModule,
        SalesModule,
        PartsModule,
        PurchaseOrdersModule,
        SharedModule,
        PortalModule,
        ConfirmationsModule,
        BuildAssembliesModule,
        WeldShopModule,
        SchedulingModule,
        ContactLogsModule,
        InventoryProjectionsModule,
        IonicModule.forRoot(),
        ExpenseReportsModule,
        UpdateBannerComponent,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
